'use client';

import { useRouter } from 'next/router';
import SeoHead from '@/components/seo/SeoHead';
import {
  buildOrganizationJsonLd,
  buildWebPageJsonLd,
  buildWebSiteJsonLd,
  isNoIndexPath,
  SEO_PAGES,
} from '@/lib/seo';

/**
 * SEO for public marketing/legal routes in SEO_PAGES.
 * Private panels (/user, /agent, /admin) set their own SeoHead in layout components.
 */
export default function DefaultSeo() {
  const { pathname } = useRouter();

  if (isNoIndexPath(pathname)) return null;

  const config = SEO_PAGES[pathname];
  if (!config) return null;

  const jsonLd = [
    buildOrganizationJsonLd(),
    pathname === '/' ? buildWebSiteJsonLd() : null,
    buildWebPageJsonLd({
      title: config.title,
      description: config.description,
      path: config.path,
    }),
  ].filter(Boolean);

  return (
    <SeoHead
      title={config.title}
      description={config.description}
      path={config.path}
      jsonLd={jsonLd}
    />
  );
}
